<script>
export default {
    name: 'ToastHandler',
    data() {
        return {
            myToast: {},
            position: 'bottom-left',
            fullWidth: false,
            theme: 'toasted-primary',
            message: '',
        }
    },
    methods: {
        showSearchingToast() {
            this.myToast = this.$toasted.info('Recherche en cours', {
                icon: {
                    name: 'search',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showRecordingToast() {
            this.myToast = this.$toasted.info('Enregistrement en cours', {
                icon: {
                    name: 'save',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showDeletingToast() {
            this.myToast = this.$toasted.info('Suppression en cours', {
                icon: {
                    name: 'delete',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showSendingToast() {
            this.myToast = this.$toasted.info('Envoi en cours', {
                icon: {
                    name: 'email',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showProcessingToast() {
            this.myToast = this.$toasted.info('Génération en cours', {
                icon: {
                    name: 'autorenew',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showDownloadingToast() {
            this.myToast = this.$toasted.info(
                'Récupération des données en cours',
                {
                    icon: {
                        name: 'cloud_downloading',
                    },
                    theme: this.theme,
                    position: this.position,
                    fullWidth: this.fullWidth,
                    className: ['info-toast'],
                }
            )
        },

        showUploadingToast() {
            this.myToast = this.$toasted.info('Stockage du fichier en cours', {
                icon: {
                    name: 'save',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                className: ['info-toast'],
            })
        },

        showSuccessToast(message) {
            this.myToast = this.$toasted.info(message, {
                icon: {
                    name: 'sentiment_satisfied_alt',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                duration: 4000,
                className: ['success-toast'],
            })
        },
        showUploadErrorToast(status) {
            this.closeToast()
            if (status === 403) {
                this.message = "Vous n'êtes pas autorisé·e à faire cette action"
            } else if (status === 401) {
                this.message = "Erreur d'authentification sur le serveur"
            } else if (status === 422) {
                this.message = "Ce format de fichier n'est pas accepté"
            } else if (status === 500) {
                this.message = "Une erreur s'est produite sur le serveur"
            } else {
                this.message = "Une erreur s'est produite"
            }
            this.myToast = this.$toasted.info(this.message, {
                icon: {
                    name: 'sentiment_very_dissatisfied',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                duration: 5000,
                className: ['error-toast'],
            })
        },
        showErrorToast(error) {
            this.closeToast()
            const { status } = error.response
            if (status === 403) {
                this.message = "Vous n'êtes pas autorisé·e à faire cette action"
            } else if (status === 401) {
                this.message = "Erreur d'authentification sur le serveur"
            } else if (status === 422) {
                this.message = this.getExplicitErrorsMessage(error)
            } else if (status === 500) {
                this.message = "Une erreur s'est produite sur le serveur"
            } else {
                this.message = "Une erreur s'est produite"
            }
            this.myToast = this.$toasted.info(this.message, {
                icon: {
                    name: 'sentiment_very_dissatisfied',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                duration: 5000,
                className: ['error-toast'],
            })
        },
        showWarningToast(message) {
            this.myToast = this.$toasted.info(message, {
                icon: {
                    name: 'sentiment_dissatisfied',
                },
                theme: this.theme,
                position: this.position,
                fullWidth: this.fullWidth,
                duration: 5000,
                className: ['warning-toast'],
            })
        },

        showSuccessOrWarningToast(meta) {
            if (meta.warning) {
                this.showWarningToast(meta.message)
            } else {
                this.showSuccessToast(meta.message)
            }
        },

        handleRecordingResponse(meta) {
            this.closeToast()
            this.showSuccessOrWarningToast(meta)
        },

        closeToast() {
            try {
                this.myToast.goAway(700)
            } catch (e) {
                //
            }
        },

        getExplicitErrorsMessage(error) {
            let explicitErrorsMessages = ''
            const { errors } = error.response.data
            for (const key in errors) {
                explicitErrorsMessages += `${errors[key][0]} - `
            }

            const message = explicitErrorsMessages.slice(0, -3)

            return message.length > 0 ? message : 'Les données sont invalides'
        },
    },
}
</script>

<style scoped></style>
